import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '../i18n';
import { ChevronDown } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';

export default function LanguageSwitcher({ variant = 'light' }) {
  const { i18n } = useTranslation();
  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[1];
  const textClass = variant === 'dark' ? 'text-white/80 hover:text-white' : 'text-[#3D2817]/70 hover:text-[#3D2817]';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="lang-switcher"
          className={`flex items-center gap-1.5 text-xs uppercase tracking-widest font-medium transition-colors ${textClass}`}
        >
          <span>{current.flag}</span>
          <span>{current.code.toUpperCase()}</span>
          <ChevronDown className="w-3 h-3" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {LANGUAGES.map(lang => (
          <DropdownMenuItem
            key={lang.code}
            data-testid={`lang-option-${lang.code}`}
            onClick={() => i18n.changeLanguage(lang.code)}
            className="cursor-pointer"
          >
            <span className="mr-3">{lang.flag}</span>
            <span className="font-sans">{lang.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
